import React from "react";

// Shared image component with graceful fallback
export default function ProductImage({ src, alt, className = "", fallbackHue = 28 }) {
  const [error, setError] = React.useState(false);
  if (!src || error) {
    // SVG gradient placeholder
    const gradient = `linear-gradient(135deg, hsl(${fallbackHue}, 70%, 30%), hsl(${fallbackHue + 20}, 45%, 15%))`;
    return (
      <div className={`flex items-center justify-center ${className}`} style={{ background: gradient }}>
        <span className="font-display text-xl text-cream/60">{alt?.split(" ")?.slice(-1)[0] || "Spice"}</span>
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt || ""}
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={() => setError(true)}
      className={className}
    />
  );
}
